import {Card, CardContent, Divider, Grid, Link, Stack, Typography} from '@mui/material';
import { useQueryClient} from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import CustomBreadcrumbs from '@/commons/custom-breadcrumbs/CustomBreadcrumbs';
import { PATH_DASHBOARD } from '@/routes/paths';
import { Icon } from '@iconify/react';
import { translates } from '@/utils';
import {useMemo} from "react";
import {Reservations, ReservationTable} from "@/services/reservations/types";
import dayjs from "dayjs";
import EmptyContent from "@commons/empty-content";
import { FieldCard } from '../components/common/fieldCard';
import { LABELS_RESERVATION, LABEL_PLAN } from '../utils/constants';

export default function ViewReservation() {
  const { id } = useParams();
 const queryClient = useQueryClient();
 const reservations: Reservations[] | undefined = queryClient.getQueryData(['reservations']);
 const reservation = useMemo(() => {
   const reservationMemo = reservations?.find?.((item) => item._id === id);
   if(!reservationMemo) return null;
    const { reserver } = reservationMemo;
     return {
         id: reservationMemo._id,
             name: reserver.name,
         email: reserver.email,
         phone: reserver.phone,
         document: reserver.document,
         message: reservationMemo.message,
         date: dayjs(reservationMemo.date).format('DD/MM/YYYY'),
         time: dayjs(reservationMemo.date).format('HH:mm'),
         attendees: reservationMemo.attendees,
         planObject: reservationMemo.plan,
         branch: reservationMemo.branch,
         plan: reservationMemo.plan?.name,
         status: reservationMemo.status,
     } as ReservationTable;
 }, [id, reservations]);
 const name = reservation?.name ? `${reservation?.name  } - ${  reservation?.document}` : `# ${id}`;

    return (
    <Grid>
      <CustomBreadcrumbs
        heading={`${translates.reservation}: ${name}`}
        links={[
          { name: translates.dashboard, href: PATH_DASHBOARD.root },
          {
            name: translates.reservations,
            href: PATH_DASHBOARD.reservations.root,
          },
          { name: String(id) },
        ]}
      />
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          justifyItems: 'center',
        }}
      >
          {reservation ?

              <Card
                  sx={{
                      width: '30rem',
                      display: 'flex',
                      justifyContent: 'center',
                      background: '#f4f6f8',
                  }}
              >
                  <CardContent
                      sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'left',
                          justifyItems: 'left',
                          justifySelf: 'left',
                      }}
                  >
                      <Typography variant="h4">{translates.reservationData}</Typography>
                      <Stack>
                          <Typography variant="subtitle1" fontSize={17} textAlign='center'>Cliente</Typography>

                          {LABELS_RESERVATION.map((label) => (
                              // @ts-ignore
                              <FieldCard label={label.label} data={reservation?.[label.key]} key={label.key}/>
                          ))}
                          <Divider />
                          <Typography variant="subtitle1" fontSize={17} textAlign='center'>Plan</Typography>
                          {LABEL_PLAN.map((label) => (
                              // @ts-ignore
                              <FieldCard label={label.label} data={reservation?.planObject?.[label.key]} key={label.key}/>
                          ))}
                          <Link
                              sx={{
                                  display: 'flex',
                                  cursor: 'pointer',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  gap: '1rem',
                                  padding: '0.5rem',
                                  border: '1px solid green',
                                  borderRadius: '2rem',
                                  margin: '1rem',
                              }}
                              target="_blank"
                              href={`https://api.whatsapp.com/send?phone=57${reservation?.phone}&text=Hola%20Buen%20Dia%2FTarde%20o%20Noche%20%F0%9F%98%83.%0A%0ATe%20escribimos%20del%20restaurante%20Weeks%2C%20para%20darte%20mas%20informacion%20sobre%20la%20reserva%20que%20hiciste.`}
                          >
                              <Icon alignmentBaseline="baseline" icon="mdi:whatsapp" width={40} color="green"/>
                              <Typography>{translates.writeWhatsapp}</Typography>
                          </Link>
                      </Stack>
                  </CardContent>
              </Card>
                  :<EmptyContent title={translates.noData}/>}
      </Grid>
    </Grid>
  );
}
